import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import BookingModal from "@/components/BookingModal";
import { ArrowRight } from "lucide-react";

const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_9bee4b07-8d72-479e-a1c0-b19de3e7f530/artifacts/13f66ozi_biro_logo_black-350x100.png";
const HERO_IMG = "https://customer-assets.emergentagent.com/job_urban-mobility-35/artifacts/swc8dfwd_Estrima-Biro.jpg";

export default function QRBooking() {
    const [bookingOpen, setBookingOpen] = useState(true);
    const [searchParams] = useSearchParams();
    const source = searchParams.get("source") || "qr";

    return (
        <div className="bg-white min-h-screen" data-testid="qr-booking-page">
            <Navbar onBookingClick={() => setBookingOpen(true)} />
            <section className="relative min-h-screen flex items-center justify-center">
                <div className="absolute inset-0">
                    <img src={HERO_IMG} alt="Birò" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black/60" />
                </div>
                <div className="relative z-10 text-center px-6 max-w-lg">
                    <img src={LOGO_BLACK} alt="Birò" className="h-8 mx-auto mb-6 invert" />
                    <h1 className="text-4xl sm:text-5xl font-light tracking-tighter text-white mb-4">Provkör Birò</h1>
                    <p className="text-base text-white/80 mb-8">Boka din 24-timmars provkörning direkt. 500 kr.</p>
                    <button data-testid="qr-booking-cta" onClick={() => setBookingOpen(true)}
                        className="inline-flex items-center gap-2 bg-white text-black px-8 py-4 text-xs uppercase tracking-[0.2em] font-medium hover:bg-neutral-100 transition-colors">
                        Boka nu <ArrowRight size={16} />
                    </button>
                </div>
            </section>
            <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} />
        </div>
    );
}
